exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 998px) {\n    .stats__item--avatar--inner.withdraw__item{\n        margin-right: 0.8rem;\n    }\n}", ""]);

// exports
